import { z } from "zod"

export const CENTRA_PRICELIST_CODE = {
    aud: "aud",
    cad: "cad",
    chf: "chf",
    czk: "czk",
    dkk: "dkk",
    eur: "eur",
    gbp: "gbp",
    jpy: "jpy",
    nok: "nok",
    nzd: "nzd",
    pln: "pln",
    sek: "sek",
    usd: "usd"
} as const

export type CentraPricelistCode =
    (typeof CENTRA_PRICELIST_CODE)[keyof typeof CENTRA_PRICELIST_CODE]

export const PricelistCodeSchema = z.enum(
    Object.values(CENTRA_PRICELIST_CODE) as [
        CentraPricelistCode,
        ...CentraPricelistCode[]
    ]
)

export const validatePricelistCode = (code: string) => {
    return PricelistCodeSchema.safeParse(code.toLowerCase())
}
